export { DataSourceManager } from "@cogo/runtime-v2"
